import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useHomeStore } from '../../store/useHomeStore'
import Loader from '../../Components/Loader'

const About = () => {
    const navigate = useNavigate()
    let [loading, setLoading] = useState(false)
    let { about, postAboutUs } = useHomeStore()

    const [data, setData] = useState({
        subTitle: '',
        title: '',
        image: null,
        description: '',
        buttonText: '',
        experience: '',
    });

    const handleSubmit = async () => {
        setLoading(true)
        await postAboutUs(data)
        setLoading(false)
    }

    const getImageSrc = (img) => {
        if (!img) return null;
        if (typeof img === "string") {
            return img;
        }
        return URL.createObjectURL(img);
    };

    useEffect(() => {
        setData({
            subTitle: about?.subTitle || '',
            title: about?.title || '',
            description: about?.description || '',
            image: about?.image || '',
            buttonText: about?.buttonText || '',
            experience: about?.experience || '',
        })
    }, [about])

    return (
        <div id="banner-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6" >
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>About Us Section</h3>
            </div>
            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">Title</label>
                            <input
                                type="text"
                                value={data?.title}
                                onChange={(e) => setData({ ...data, title: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                            <label className="block text-sm text-neutral-700 mb-2">Subtitle</label>
                            <input type="text"
                                value={data?.subTitle}
                                onChange={(e) => setData({ ...data, subTitle: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">Button Text</label>
                            <input type="text"
                                value={data?.buttonText}
                                onChange={(e) => setData({ ...data, buttonText: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">Experience</label>
                            <input type="text"
                                value={data?.experience}
                                onChange={(e) => setData({ ...data, experience: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">Image</label>
                            <div className="border-2 border-dashed border-neutral-300 rounded-md p-6 flex flex-col items-center justify-center h-3/4">
                                <i className="fa-solid fa-cloud-upload-alt text-3xl text-neutral-400 mb-2"></i>
                                <p className="text-neutral-600 mb-2">Drag and drop an image here, or click to browse</p>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setData({ ...data, image: e.target.files[0] })}
                                    className="hidden"
                                    id="projectImage"
                                />
                                <label
                                    htmlFor="projectImage"
                                    className="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-md text-sm cursor-pointer"
                                >
                                    Select File
                                </label>
                                {data?.image && <p className="mt-2 text-sm text-green-600">{data?.image?.name}</p>}
                                <div className="w-24 h-26 flex items-center justify-center text-white text-xs mr-4 mb-2">
                                    {getImageSrc(data?.image) ? (
                                        <img
                                            src={getImageSrc(data?.image)}
                                            alt="Hero"
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        'No Image'
                                    )}
                                </div>

                            </div>
                            <span className='text-sm font-medium text-gray-700'>Recomended Image Size : 800px*600px</span>
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm text-neutral-700 mb-2">Description</label>
                        <div>
                            <textarea
                                rows="4"
                                value={data?.description}
                                onChange={(e) =>
                                    setData({ ...data, description: e.target.value })
                                }
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                    </div>
                </div>
            </Loader>
            <div className="flex justify-end space-x-3 p-3">
                <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                    onClick={() => navigate(-1)}
                >Cancel</button>
                <button
                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                    onClick={() => handleSubmit()}
                >
                    Save About Section
                </button>
            </div>
        </div>
    )
}

export default About
